export default __webpack_public_path__ + "f4809ac9ae4d69ef6e153cef6d4c5ef1.png";